import { render, staticRenderFns } from "./PersonalAccounts.vue?vue&type=template&id=55f2d988&scoped=true&"
import script from "./PersonalAccounts.vue?vue&type=script&lang=js&"
export * from "./PersonalAccounts.vue?vue&type=script&lang=js&"
import style0 from "./PersonalAccounts.vue?vue&type=style&index=0&id=55f2d988&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f2d988",
  null
  
)

export default component.exports